module.exports = {
  apiUrl: process.env.VUE_APP_BACKEND,
  recaptchaKey: process.env.VUE_APP_RECAPTCHA_PUBLIC_KEY
};
